

















































































































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { membershipCategoryFields } from '@/config/subscriptions';
import ContentWrapper from '@shared/layouts/wrappers/content-wrapper.vue';
import BPCGenericApiResponse from '@core/interfaces/bpc-generic-api-response';
import { MembershipCategory } from '@subscriptions/interfaces/subscription-category';
import FormProvider from '@shared/components/forms/form-provider.vue';
import Datepicker from '@shared/components/forms/inputs/datepicker/datepicker.vue';
import Input from '@shared/components/forms/inputs/input/input.vue';
import InputGroup from '@shared/components/forms/inputs/input-group/input-group.vue';
import Select from '@shared/components/forms/inputs/select/select.vue';
import Switch from '@shared/components/forms/inputs/switch/switch.vue';
import Textarea from '@shared/components/forms/inputs/textarea/textarea.vue';
import EntitySelect from '@shared/components/forms/inputs/entity-select/entity-select.vue';
import EntityTableInput from '@shared/components/forms/inputs/entity-table-input/entity-table-input.vue';
import MessageEntityTable from '@shared/components/forms/inputs/message-entity-table/message-entity-table.vue';
import ActivityLogTimelineInput from '@shared/components/forms/inputs/activity-log-timeline-input/activity-log-timeline-input.vue';
import moment from 'moment';
import MembershipCategoryCard from '@subscriptions/components/cards/admin/membership-category-card.vue';
import MembershipCategoryForm from '@subscriptions/components/forms/admin/membership-category-form.vue';
import MembershipList from '@subscriptions/components/lists/admin/membership-list.vue';
import MembershipPaymentList from '@subscriptions/components/lists/admin/membership-payment-list.vue';
import MessageList from '@communications/components/lists/message-list.vue';
import { BPCTableField } from '@shared/interfaces/bpc-table-interface';

@Component({
  name: 'bpc-membership-category-single',
  components: {
    'bpc-content-wrapper': ContentWrapper,
    'bpc-form-provider': FormProvider,
    'bpc-input': Input,
    'bpc-input-group': InputGroup,
    'bpc-select': Select,
    'bpc-textarea': Textarea,
    'bpc-datepicker': Datepicker,
    'bpc-switch': Switch,
    'bpc-entity-select': EntitySelect,
    'bpc-entity-table-input': EntityTableInput,
    'bpc-message-entity-table': MessageEntityTable,
    'bpc-activity-log-timeline': ActivityLogTimelineInput,
    'bpc-membership-category-card': MembershipCategoryCard,
    'bpc-membership-category-form': MembershipCategoryForm,
    'bpc-membership-list': MembershipList,
    'bpc-membership-payment-list': MembershipPaymentList,
    'bpc-message-list': MessageList,
  },
})
export default class MembershipCategorySingle extends Vue {
  $refs!: {
    formProvider: InstanceType<typeof FormProvider> & {
      errorsObject: object;
      saveEntity(formModel: AnyEntity): Promise<BPCGenericApiResponse>;
      resetErrorObject(): void;
    };
  };
  // PROPS
  @Prop(Object) readonly initialData: MembershipCategory;
  @Prop(Number) readonly modelId: number;
  @Prop({ type: String, default: '' }) readonly componentId: string;
  @Prop({ type: String, default: 'page' }) readonly displayMode: string;
  @Prop({ type: String, default: 'edition' }) readonly actionMode: string;
  @Prop({ type: Boolean, default: false }) readonly show: boolean;
  @Prop({ type: Boolean, default: false }) readonly noFetchData: boolean;

  // DATA
  formModel: MembershipCategory = null;
  dataLoaded: boolean = false;
  timestamp = moment().unix();
  selectedTab = 0;

  membershipTableFields: BPCTableField[] = [
    {
      key: 'contact.fullname',
      headerLabel: `global.subscription.contact_id.label`,
      order: 0,
    },
    {
      key: 'start_date',
      headerLabel: 'global.subscription.start_date.header_label',
      order: 1,
    },
    {
      key: 'end_date',
      headerLabel: 'global.subscription.end_date.header_label',
      order: 2,
    },
    {
      key: 'status',
      headerLabel: `global.status.label`,
      order: 3,
    },
    {
      key: 'paid_amount',
      headerLabel: 'subscriptions.membership.paid_amount.header_label',
      order: 4,
    },
    {
      key: 'balance',
      headerLabel: 'subscriptions.membership.balance.header_label',
      order: 5,
    },
    {
      key: 'price',
      headerLabel: 'global.subscription.subscription_price.label',
      order: 6,
    },
    {
      key: 'payment_status',
      headerLabel: '',
      order: 7,
    },
  ];

  // COMPUTED
  get membershipCategoryCardButtonsPortalTarget() {
    return `membership-category-card-footer-buttons-${this.timestamp}`;
  }

  get membershipCategoryTabActionsPortalTarget() {
    return `membership-category-tab-actions-${this.timestamp}`;
  }

  get paymentTabActionsPortalTarget() {
    return `payment-tab-actions-${this.timestamp}`;
  }

  get messageTabActionsPortalTarget() {
    return `message-tab-actions-${this.timestamp}`;
  }

  get membershipCategoryId(): string | number {
    return this.formModel?.id || this.$route.params?.id || null;
  }

  get fieldsConfig() {
    return membershipCategoryFields;
  }

  get formattedFixedStartDate(): string {
    return this.formModel?.fixed_start_date
      ? moment(this.formModel.fixed_start_date).format('DD/MM/YYYY')
      : '';
  }
  get formattedFixedEndDate(): string {
    return this.formModel?.fixed_end_date
      ? moment(this.formModel.fixed_end_date).format('DD/MM/YYYY')
      : '';
  }
  get period(): string {
    const start = this.formattedFixedStartDate;
    const end = this.formattedFixedEndDate;
    if (start && end) {
      return `${start} - ${end}`;
    } else if (start) {
      return `From ${end}`;
    } else if (end) {
      return `Until ${end}`;
    }
    return '';
  }

  get membershipCategoryFilters() {
    return [
      {
        filterField: 'subscription_category_id',
        modelField: 'id',
        value: this.modelId,
      },
    ];
  }
  get paymentFilters() {
    return [
      {
        filterField: 'subscription_category_id',
        modelField: 'id',
        value: this.modelId,
      },
    ];
  }
  get messageTableFilters() {
    return [
      {
        filterField: 'related_entity_name',
        value: 'subscription_category',
      },
      {
        filterField: 'related_entity_id',
        modelField: 'id',
        value: this.modelId,
      },
    ];
  }

  get label() {
    return {
      labelAttributes: {
        for: 'test',
      },
      labelClass: {
        'mt-1 mb-0': true,
      },
    };
  }
  get col6() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-6 pl-2': true,
        },
      },
    };
  }
  get col12() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-12 pl-2': true,
        },
      },
    };
  }
  get col3() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-3 pl-2': true,
        },
      },
    };
  }
  get col4() {
    return {
      wrapperAttributes: {
        class: {
          'inline-field col-md-4 pl-2': true,
        },
      },
    };
  }

  get isSuperAdmin(): boolean {
    return this.$store.getters['auth/isSuperAdmin'];
  }

  // public formModel: MembershipCategory = null;

  // LIFECYCLE
  // created(){}
  mounted() {
    this.initModel();
  }
  // updated(){}
  // destroyed(){}

  // METHODS

  async initModel() {
    this.dataLoaded = false;

    if (this.initialData) {
      this.formModel = this.initialData;
    }
    if (!this.noFetchData) {
      await this.fetchData();
    }
    this.dataLoaded = true;
    if (!this.noFetchData) {
      await this.fetchAccountingData();
    }
  }

  async fetchData() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('membership-category');
    const path = `${basePath}/${this.modelId}`;
    const res = await this.$bpcApi.get(path).toPromise();
    this.formModel = {
      ...res.data,
      total_orders_price: null,
      total_payments_paid: null,
    };
  }

  async fetchAccountingData() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('membership-category');
    const path = `${basePath}/${this.modelId}/accounting`;
    const res = await this.$bpcApi.get(path).toPromise();

    const model = {
      ...this.formModel,
      total_orders_price: res.data.total_orders_price,
      total_payments_paid: res.data.total_payments_paid,
    };

    this.formModel = model;
  }

  onEntitySaved(e) {
    this.$emit('entity-saved', e);
    this.onClose();
  }

  onEntityErrorSaving(e) {
    this.$bpcMessage.showErrorMessage({ text: 'core.superadmin_form_update_errors' });
    this.$emit('entity-error-saving', e);
  }

  onValidationWarning(e) {
    this.$emit('validation-warning', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  onModelLoaded(event) {
    this.$emit('model-loaded', event);
  }

  async onMembershipSaved() {
    await this.fetchData();
    await this.fetchAccountingData();
  }

  onConfigLoaded(event) {
    this.$emit('config-loaded', event);
  }

  onClose() {
    this.$emit('close');
  }

  // WATCHERS
}
